/* A change to one exercise under review (board U): `ExerciseBlock`'s card, read-only. Everything
 * but the head's tag is the block's own stylesheet. */

.card {
  flex: none;
}

/* „4 → 5 serii", „Nowe w miejscu 2": the board's `.tag`, at the head's right end in the secondary
 * ink, as the block's own folded summary stands there. */
.tag {
  flex: none;
  margin-inline-start: auto;
  font-size: var(--fs-label-sm);
  font-weight: var(--fw-bold);
  color: var(--text-2);
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
}

/* The name wraps rather than ellipsising: the card sits in a 448px panel beside a tag, and a change
 * under review is read whole. */
.card h4 {
  white-space: normal;
  overflow-wrap: anywhere;
}
